<template>
    <v-dialog v-model="emailModal" max-width="500px">
        <v-card>
            <div class="modal-header">
                <h4 class="modal-headline">{{ $page.props.lang.new_email || 'New Email' }}</h4>
                <v-btn icon @click="emailModal = false"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div>
                <v-card-text>
                  <v-container>
                      <div class="fields">
                           <div class="form-group">
                              <label class="custom-label">{{ $page.props.lang.send_to || 'Send to' }}</label>
                              <v-select v-model="message.member_type" :items="memberTypes" 
                              text="text" value="value" outlined dense
                              :error-messages="responseErrors.member_type" 
                              :hide-details="!responseErrors.member_type" ></v-select>
                          </div>
                          <div class="form-group">
                              <label class="custom-label">{{ $page.props.lang.subject || 'Subject' }}</label>
                              <v-text-field v-model="message.subject" outlined dense></v-text-field>
                          </div>
                          <div class="form-group">
                            <label class="custom-label">{{ $page.props.lang.message || 'Message' }}</label>
                            <vue-editor ref="editor" :editor-toolbar="customToolbar" style="margin-bottom:10px;"
                                v-model="message.content"
                                :hide-details="!responseErrors.content"
                                :error-mesasges="responseErrors.content" @focus="responseErrors.content=''">
                            </vue-editor>
                            <v-btn @click="addPlaceholder('{first_name}')" x-small color="primary">{{ $page.props.lang.first_name || "First name" }}</v-btn> 
                            <v-btn @click="addPlaceholder('{last_name}')" x-small color="primary">{{ $page.props.lang.last_name || "Last name" }}</v-btn>
                          </div>   
                      </div>
                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="regular" @click="emailModal = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                          <v-btn color="primary" @click="sendMail" :loading="sendingEmail">{{ $page.props.lang.send || "Send" }}</v-btn>    
                      </v-card-actions>
                  </v-container>
                </v-card-text>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>

import EventBus from '@/js/eventbus'
import { VueEditor, Quill } from "vue2-editor";

export default {
    components: { VueEditor },
    props: {
        open: Boolean
    },
    data(){
      return {
        message:{
            member_type:'',
            subject:'',
            content:''
        },
        responseErrors:{},
        memberTypes: [
            { value: '0', text: this.$page.props.lang.to_all || 'All'},
            { value: '1', text: this.$page.props.lang.to_active || 'Active'},
            { value: '2', text: this.$page.props.lang.to_inactive || 'Inactive'},
        ],
        sendingEmail: false,
        customToolbar: [ [{ 'size': ['small', 'medium', 'large', 'huge'] }],   ["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }] ]
      }
    },
    computed: {
        emailModal: {
            get: function() {
                return this.open
            },
            set: function() {
                this.$emit('close')
                return false
            }
        }
    },
    
    methods:{
        addPlaceholder(placeholder){
            this.$refs.editor.quill.focus();
            var position = this.$refs.editor.quill.getSelection();
            this.$refs.editor.quill.insertText(position.index, placeholder);
        },
        sendMail(){
            this.sendingEmail = true;
            axios.post('/backoffice/messages/sendMail', this.message)
            .then(response => {
                    this.sendingEmail = false;
                    if(response.data.status==="OK") {
                        
                        this.$inertia.reload()
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                      this.emailModal = false;
                    }
                })
                .catch(error => {
                    this.sendingEmail = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                   
                    this.responseErrors = error.response.data.errors
                });
        }
    }
    
}
</script>